import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import React from "react";

export const Info = ({ data }) => {
  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Box
      py={{ xs: 6, md: 10 }}
      display="flex"
      justifyContent="center"
      sx={{ backgroundColor: data.imageFirst ? "transparent" : "var(--clr-warm-bg)" }}
    >
      <Grid
        display="grid"
        alignItems="center"
        container
        maxWidth="xl"
        columnSpacing={{ xs: 2, md: 8 }}
        gridTemplateColumns={{
          xs: "1fr",
          md: data.imageFirst ? "1.2fr 1fr" : "1fr 1.2fr",
        }}
        gridTemplateAreas={
          data.imageFirst
            ? { xs: '"col1" "col2"', md: '"col1 col2"' }
            : { xs: '"col1" "col2"', md: '"col2 col1"' }
        }
        px={{ xs: 2, md: 4 }}
      >
        {/* IMAGE */}
        <Grid item gridArea="col1">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              justifyContent: {
                xs: "center",
                md: data.imageFirst ? "left" : "right",
              },
            }}
          >
            <Box
              sx={{
                overflow: "hidden",
                position: "relative",
                "&:hover img": {
                  transform: "scale(1.03)",
                },
              }}
            >
              <img
                src={require(`assets/images/${data.image}`)}
                alt={data.title}
                style={{
                  maxHeight: "500px",
                  maxWidth: "100%",
                  display: "block",
                  transition: "transform 0.8s ease",
                  filter: "brightness(0.85)",
                }}
              />
            </Box>
          </Box>
        </Grid>
        {/* TEXT */}
        <Grid item gridArea="col2">
          <Container maxWidth="md">
            <Box
              width="100%"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              py={{ xs: 4, md: 0 }}
            >
              <Container maxWidth="xl">
                {/* Gold accent line */}
                <Box
                  sx={{
                    width: 50,
                    height: "2px",
                    background: "var(--clr-primary)",
                    mb: 2.5,
                    mx: isFullWidth ? "auto" : 0,
                  }}
                />
                <Typography
                  variant="h6"
                  color="primary"
                  textAlign={isFullWidth ? "center" : undefined}
                  sx={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontWeight: 500,
                    fontSize: { xs: "1.3rem", md: "1.5rem" },
                    letterSpacing: "0.08em",
                  }}
                >
                  {data.title}
                </Typography>
                <Typography
                  variant="body1"
                  color="common.black"
                  mt={{ xs: 2, md: 3 }}
                  textAlign={isFullWidth ? "center" : undefined}
                  sx={{
                    lineHeight: 1.9,
                    fontSize: { xs: "0.9rem", md: "0.95rem" },
                    color: "#4a4a4a",
                  }}
                >
                  {data.text}
                </Typography>
              </Container>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </Box>
  );
};
